import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useClearAbandonedEnrollment = () => {
  const res = useMutation((prescriberId) =>
    http.delete(
      HTTP_ENDPOINTS.prescribers.clearAbandonedEnrollment(prescriberId),
    ),
  );
  return res;
};
